const E164_MAX_DIGITS = 15;
const DEFAULT_COUNTRY_CODE_MAX_LENGTH = 4;
const TURKEY_COUNTRY_CODE = "90";
const FALLBACK_NATIONAL_NUMBER_MIN_LENGTH = 6;

// Derived from Google libphonenumber fixed-line/mobile possible lengths.
// Keys are country calling codes, so shared calling codes use the union of possible lengths.
const NATIONAL_NUMBER_LENGTHS_BY_COUNTRY_CODE = {
  "1": [10],
  "7": [10],
  "20": [8, 9, 10],
  "27": [5, 6, 7, 8, 9],
  "30": [10],
  "31": [9, 11],
  "32": [8, 9],
  "33": [9],
  "34": [9],
  "36": [8, 9],
  "39": [6, 7, 8, 9, 10, 11, 12],
  "40": [6, 9],
  "41": [9],
  "43": [4, 5, 6, 7, 8, 9, 10, 11, 12, 13],
  "44": [9, 10],
  "45": [8],
  "46": [7, 8, 9],
  "47": [8],
  "48": [7, 9],
  "49": [5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15],
  "51": [8, 9],
  "52": [10],
  "53": [6, 7, 8, 10],
  "54": [10, 11],
  "55": [10, 11],
  "56": [9],
  "57": [8, 10],
  "58": [10],
  "60": [8, 9, 10],
  "61": [9],
  "62": [7, 8, 9, 10, 11, 12],
  "63": [6, 8, 9, 10],
  "64": [8, 9, 10],
  "65": [8],
  "66": [8, 9],
  "81": [9, 10],
  "82": [5, 6, 8, 9, 10],
  "84": [9, 10],
  "86": [7, 8, 9, 10, 11],
  "90": [10],
  "91": [10],
  "92": [9, 10],
  "93": [9],
  "94": [9],
  "95": [6, 7, 8, 9, 10],
  "98": [6, 7, 10],
  "211": [9],
  "212": [9],
  "213": [8, 9],
  "216": [8],
  "218": [9],
  "220": [7],
  "221": [9],
  "222": [8],
  "223": [8],
  "224": [8, 9],
  "225": [10],
  "226": [8],
  "227": [8],
  "228": [8],
  "229": [10],
  "230": [7, 8],
  "231": [7, 8, 9],
  "232": [8],
  "233": [9],
  "234": [10],
  "235": [8],
  "236": [8],
  "237": [9],
  "238": [7],
  "239": [7],
  "240": [9],
  "241": [7, 8],
  "242": [9],
  "243": [7, 8, 9, 10],
  "244": [9],
  "245": [9],
  "246": [7],
  "247": [5],
  "248": [7],
  "249": [9],
  "250": [8, 9],
  "251": [9],
  "252": [6, 7, 8, 9],
  "253": [8],
  "254": [7, 8, 9],
  "255": [9],
  "256": [9],
  "257": [8],
  "258": [8, 9],
  "260": [9],
  "261": [9],
  "262": [9],
  "263": [5, 6, 7, 8, 9, 10],
  "264": [8, 9],
  "265": [7, 9],
  "266": [8],
  "267": [7, 8],
  "268": [8],
  "269": [7],
  "290": [4, 5],
  "291": [7],
  "297": [7],
  "298": [6],
  "299": [6],
  "350": [8],
  "351": [9],
  "352": [4, 5, 6, 7, 8, 9, 10, 11],
  "353": [7, 8, 9, 10],
  "354": [7, 9],
  "355": [8, 9],
  "356": [8],
  "357": [8],
  "358": [5, 6, 7, 8, 9, 10],
  "359": [6, 7, 8, 9],
  "370": [8],
  "371": [8],
  "372": [7, 8],
  "373": [8],
  "374": [8],
  "375": [9],
  "376": [6, 9],
  "377": [8, 9],
  "378": [8, 10],
  "380": [9],
  "381": [7, 8, 9, 10, 11, 12],
  "382": [8],
  "383": [8, 9, 10, 11, 12],
  "385": [8, 9],
  "386": [8],
  "387": [8, 9],
  "389": [8],
  "420": [9],
  "421": [6, 7, 9],
  "423": [7, 9],
  "500": [5],
  "501": [7],
  "502": [8],
  "503": [8],
  "504": [8],
  "505": [8],
  "506": [8],
  "507": [7, 8],
  "508": [6, 9],
  "509": [8],
  "590": [9],
  "591": [8],
  "592": [7],
  "593": [8, 9],
  "594": [9],
  "595": [7, 8, 9],
  "596": [9],
  "597": [6, 7],
  "598": [8],
  "599": [7, 8],
  "670": [7, 8],
  "672": [6],
  "673": [7],
  "674": [7],
  "675": [7, 8],
  "676": [5, 7],
  "677": [5, 7],
  "678": [5, 7],
  "679": [7],
  "680": [7],
  "681": [6],
  "682": [5],
  "683": [4, 7],
  "685": [5, 6, 7, 10],
  "686": [5, 8],
  "687": [6],
  "688": [5, 6, 7],
  "689": [8],
  "690": [4, 5, 6, 7],
  "691": [7],
  "692": [7],
  "800": [8],
  "808": [8],
  "850": [8, 10],
  "852": [8],
  "853": [8],
  "855": [8, 9],
  "856": [8, 9, 10],
  "870": [9, 12],
  "878": [12],
  "880": [6, 7, 8, 9, 10],
  "881": [9, 10],
  "882": [7, 8, 9, 10, 12],
  "883": [8, 9, 10, 11, 12],
  "886": [8, 9],
  "888": [11],
  "960": [7],
  "961": [7, 8],
  "962": [8, 9],
  "963": [8, 9],
  "964": [8, 9, 10],
  "965": [8],
  "966": [9],
  "967": [7, 8, 9],
  "968": [8],
  "970": [8, 9],
  "971": [8, 9],
  "972": [8, 9, 11, 12],
  "973": [8],
  "974": [8],
  "975": [7, 8],
  "976": [8, 9, 10],
  "977": [8, 10],
  "979": [9],
  "992": [9],
  "993": [8],
  "994": [9],
  "995": [9],
  "996": [9],
  "998": [9],
};

const KNOWN_COUNTRY_CODES_DESC = Object.keys(NATIONAL_NUMBER_LENGTHS_BY_COUNTRY_CODE)
  .sort((a, b) => b.length - a.length || a.localeCompare(b));

export const digitsOnly = (value) => String(value ?? "").replace(/\D/g, "");

export const normalizeCountryCode = (value, { maxLength = DEFAULT_COUNTRY_CODE_MAX_LENGTH } = {}) => {
  return digitsOnly(value).slice(0, maxLength);
};

const getFallbackNationalNumberMaxLength = (countryCode) => {
  const ccLength = countryCode ? countryCode.length : 0;
  return Math.max(4, Math.min(14, E164_MAX_DIGITS - ccLength));
};

const isConsecutive = (lengths) => {
  if (!Array.isArray(lengths) || lengths.length <= 1) return true;
  return lengths.every((length, index) => index === 0 || length === lengths[index - 1] + 1);
};

const formatLengthList = (lengths) => {
  if (!Array.isArray(lengths) || lengths.length === 0) return "";
  if (lengths.length === 1) return String(lengths[0]);
  const head = lengths.slice(0, -1).join(", ");
  return `${head} veya ${lengths[lengths.length - 1]}`;
};

const buildParts = (countryCode, nationalNumber) => ({
  countryCode,
  phone: nationalNumber,
  national: nationalNumber,
});

export const getNationalNumberLengthRule = (countryCode) => {
  const cc = normalizeCountryCode(countryCode);
  const lengths = NATIONAL_NUMBER_LENGTHS_BY_COUNTRY_CODE[cc];

  if (lengths?.length) {
    return {
      countryCode: cc,
      lengths,
      min: lengths[0],
      max: lengths[lengths.length - 1],
      isKnownCountryCode: true,
    };
  }

  const max = getFallbackNationalNumberMaxLength(cc);
  const min = Math.min(FALLBACK_NATIONAL_NUMBER_MIN_LENGTH, max);
  return {
    countryCode: cc,
    lengths: null,
    min,
    max,
    isKnownCountryCode: false,
  };
};

export const getNationalNumberMaxLength = (countryCode) => {
  return getNationalNumberLengthRule(countryCode).max;
};

export const getNationalNumberMinLength = (countryCode) => {
  return getNationalNumberLengthRule(countryCode).min;
};

export const normalizeNationalNumber = (value, countryCode) => {
  const rule = getNationalNumberLengthRule(countryCode);
  return digitsOnly(value).slice(0, rule.max);
};

export const isValidNationalNumber = (countryCode, nationalNumber) => {
  const cc = normalizeCountryCode(countryCode);
  const digits = digitsOnly(nationalNumber);
  if (!cc || !digits) return false;

  const rule = getNationalNumberLengthRule(cc);
  if (rule.lengths?.length) return rule.lengths.includes(digits.length);
  return digits.length >= rule.min && digits.length <= rule.max;
};

export const getNationalNumberValidationMessage = (countryCode) => {
  const rule = getNationalNumberLengthRule(countryCode);

  if (rule.lengths?.length) {
    if (rule.lengths.length === 1) return `${rule.min} haneli geçerli bir numara giriniz.`;
    if (isConsecutive(rule.lengths)) {
      return `${rule.min}-${rule.max} haneli geçerli bir numara giriniz.`;
    }
    return `${formatLengthList(rule.lengths)} haneli geçerli bir numara giriniz.`;
  }

  if (rule.min === rule.max) return `${rule.min} haneli geçerli bir numara giriniz.`;
  return `Geçerli bir numara giriniz. (${rule.min}-${rule.max} hane)`;
};

const groupDigits = (digits, groups, separator = " ") => {
  if (!digits) return "";
  const parts = [];
  let idx = 0;

  for (const size of groups) {
    if (idx >= digits.length) break;
    parts.push(digits.slice(idx, idx + size));
    idx += size;
  }

  if (idx < digits.length) parts.push(digits.slice(idx));
  return parts.join(separator).trim();
};

export const formatNationalNumber = (nationalNumber, countryCode) => {
  const cc = normalizeCountryCode(countryCode);
  const digits = digitsOnly(nationalNumber);
  if (!digits) return "";

  if (cc === TURKEY_COUNTRY_CODE) {
    if (digits.length <= 7) return groupDigits(digits, [3, 2, 2]);
    return groupDigits(digits, [3, 3, 2, 2]);
  }
  if (cc === "1") return groupDigits(digits, [3, 3, 4]);
  return groupDigits(digits, [3, 3, 3, 3, 3]);
};

const buildGenericPlaceholder = (countryCode) => {
  const length = getNationalNumberMaxLength(countryCode);
  const digits = "123456789012345".slice(0, length);
  return groupDigits(digits, [3, 3, 3, 3, 3]);
};

export const getNationalNumberPlaceholder = (countryCode) => {
  const cc = normalizeCountryCode(countryCode);
  if (cc === TURKEY_COUNTRY_CODE) return "555 555 55 55";
  if (cc === "1") return "555 555 5555";
  return buildGenericPlaceholder(cc);
};

export const getCountryCodeFromInternationalNumber = (value) => {
  const digits = digitsOnly(value);
  if (!digits) return "";
  return KNOWN_COUNTRY_CODES_DESC.find((countryCode) => digits.startsWith(countryCode)) || "";
};

const getNationalCandidateWithCountryCode = (digits, countryCode) => {
  const cc = normalizeCountryCode(countryCode);
  if (!cc || !digits.startsWith(cc)) return "";

  const candidate = digits.slice(cc.length);
  if (isValidNationalNumber(cc, candidate)) return candidate;
  if (digits.length > getNationalNumberMaxLength(cc)) return candidate;
  return "";
};

export const parsePhoneNumberParts = (rawPhone, fallbackCountryCode = TURKEY_COUNTRY_CODE) => {
  const fallbackCc = normalizeCountryCode(fallbackCountryCode || TURKEY_COUNTRY_CODE) || TURKEY_COUNTRY_CODE;
  const raw = String(rawPhone ?? "").trim();
  const compactRaw = raw.replace(/\s+/g, "");
  const digits = digitsOnly(compactRaw);

  if (!digits) return buildParts(fallbackCc, "");

  const internationalDigits = compactRaw.startsWith("+")
    ? digits
    : compactRaw.startsWith("00")
      ? digits.slice(2)
      : "";

  if (internationalDigits) {
    const detectedCc = getCountryCodeFromInternationalNumber(internationalDigits);
    if (detectedCc) {
      return buildParts(
        detectedCc,
        normalizeNationalNumber(internationalDigits.slice(detectedCc.length), detectedCc)
      );
    }
  }

  const nationalCandidate = getNationalCandidateWithCountryCode(digits, fallbackCc);
  if (nationalCandidate) {
    return buildParts(fallbackCc, normalizeNationalNumber(nationalCandidate, fallbackCc));
  }

  // Ulusal ŞEBEKE ÖNEKİ (baştaki 0) soyulur: "05321234567" gibi en yaygın TR yazımında
  // normalizeNationalNumber 11 haneyi 10'a KIRPARKEN son haneyi atıyor ve "+900532123456"
  // gibi geçersiz bir numara üretiliyordu. Önek atıldıktan sonra kalan geçerliyse onu alırız.
  if (digits.length > 1 && digits.startsWith("0")) {
    const withoutTrunkPrefix = digits.replace(/^0+/, "");
    if (withoutTrunkPrefix && isValidNationalNumber(fallbackCc, withoutTrunkPrefix)) {
      return buildParts(fallbackCc, normalizeNationalNumber(withoutTrunkPrefix, fallbackCc));
    }
  }

  return buildParts(fallbackCc, normalizeNationalNumber(digits, fallbackCc));
};

export const toE164 = (countryCode, nationalNumber) => {
  const cc = normalizeCountryCode(countryCode);
  const nn = normalizeNationalNumber(nationalNumber, cc);
  if (!cc || !nn) return "";
  return `+${cc}${nn}`;
};
